<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    <div class="mb-8">
      <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
        >New pool</span
      >
      <h1 class="font-display text-3xl font-semibold text-parchment">Create a competition</h1>
      <p class="mt-3 text-dusk">
        You'll get an invite code once it's created — share it to let others join.
      </p>
    </div>

    <form
      [formGroup]="form"
      (ngSubmit)="submit()"
      class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
    >
      <div class="flex flex-col gap-2">
        <label for="name" class="text-sm font-medium text-parchment">Name</label>
        <input
          id="name"
          type="text"
          formControlName="name"
          class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
          placeholder="Ghoul Pool 2026"
        />
        @if (form.controls.name.invalid && form.controls.name.touched) {
          <p class="text-sm text-wax-bright">A name is required.</p>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="startDate" class="text-sm font-medium text-parchment">Start date</label>
        <input
          id="startDate"
          type="date"
          formControlName="startDate"
          class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment focus:border-gold focus:outline-none"
        />
        @if (form.controls.startDate.invalid && form.controls.startDate.touched) {
          <p class="text-sm text-wax-bright">A start date is required.</p>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="endDate" class="text-sm font-medium text-parchment">End date</label>
        <input
          id="endDate"
          type="date"
          formControlName="endDate"
          class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment focus:border-gold focus:outline-none"
        />
        @if (form.controls.endDate.invalid && form.controls.endDate.touched) {
          <p class="text-sm text-wax-bright">An end date is required.</p>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="submissionEndDate" class="text-sm font-medium text-parchment"
          >Submission cutoff</label
        >
        <input
          id="submissionEndDate"
          type="date"
          formControlName="submissionEndDate"
          class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment focus:border-gold focus:outline-none"
        />
        <p class="text-xs text-dusk">When picks lock in — must fall between the start and end dates.</p>
        @if (form.controls.submissionEndDate.invalid && form.controls.submissionEndDate.touched) {
          <p class="text-sm text-wax-bright">A submission cutoff date is required.</p>
        }
      </div>

      @if (errorMessage()) {
        <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
          {{ errorMessage() }}
        </p>
      }

      <button
        type="submit"
        [disabled]="submitting()"
        class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
      >
        {{ submitting() ? 'Creating…' : 'Create Competition' }}
      </button>
    </form>

    <p class="mt-6 text-center text-sm text-dusk">
      <a routerLink="/competitions" class="font-medium text-parchment hover:underline"
        >Back to my competitions</a
      >
    </p>
  </div>
</section>
